import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';

import ImageFill from '@/modules/foundation/components/image/ImageFill';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import {Paragraph} from '@/modules/foundation/components/typography/paragraph';

interface Props {
	href: string;
	title: string;
	image?: ImageWeb;
}

const LinkCard: FC<Props> = ({image, href, title}) => {
	return (
		<Link
			href={href}
			className={clsx(
				'flex',
				'flex-col',
				'bg-white',
				'shadow-[0_4px_4px_0px_rgba(0,74,127,0.25)]',
				'rounded-t-3xl',
				'rounded-b-lg',
				'overflow-hidden',
				'hover:underline',
			)}
		>
			<div className={clsx('relative', 'aspect-[4/3]', 'bg-gray-100')}>
				{image && (
					<ImageFill
						src={image.image.src}
						width={image.image.width}
						height={image.image.height}
						hotspot={image.image.hotspot}
						alt={image.altText ?? ''}
					/>
				)}
			</div>
			<div className={clsx('py-5', 'px-7')}>
				<Paragraph asChild size="medium" className="font-bold">
					<span>{title}</span>
				</Paragraph>
			</div>
		</Link>
	);
};

export default LinkCard;
